import { render, staticRenderFns } from "./Box10.vue?vue&type=template&id=814e363a&scoped=true&"
import script from "./Box10.vue?vue&type=script&lang=js&"
export * from "./Box10.vue?vue&type=script&lang=js&"
import style0 from "./Box10.vue?vue&type=style&index=0&id=814e363a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814e363a",
  null
  
)

export default component.exports